import React, { type ComponentProps } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@fs/zion-ui'
import { ContentAdd } from '@fs/zion-icon'

export default function AddNoteButton(buttonProps: Partial<ComponentProps<typeof Button>>): JSX.Element {
  const [t] = useTranslation()
  return (
    <Button Icon={ContentAdd} data-testid="add-note-button" {...buttonProps}>
      {t('tree-person.add-note.action')}
    </Button>
  )
}
